export enum UIEventExtension {
    BET_QUANTITY_UP = 'onBetQuantityUp',
    BET_QUANTITY_DOWN = 'onBetQuantityDown',
    BET_QUANTITY_MAX = 'onBetQuantityMax',
    
    TOTAL_BET_UP = 'onTotalBetUp',
    TOTAL_BET_DOWN = 'onTotalBetDown',
}
